// extracted by mini-css-extract-plugin
export var card = "_71-0";
export var failedIcon = "_71-4";
export var failedIconBadge = "_71-3";
export var icon = "_71-1";
export var successIcon = "_71-2";